import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { useAdminStats } from "@/hooks/useAdminStats";
import { Loader2, AlertTriangle } from "lucide-react";
import { useMonthlyRevenue } from "@/hooks/useMonthlyRevenue";
import { SummaryCards } from "@/components/admin/dashboard/SummaryCards";
import { RevenueChart } from "@/components/admin/dashboard/RevenueChart";
import { SubscriptionCharts } from "@/components/admin/dashboard/SubscriptionCharts";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useEffect } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const AdminDashboard = () => {
  const {
    stats,
    loading: statsLoading,
    error: statsError,
    fetchStats
  } = useAdminStats();
  const {
    data: monthlyRevenue,
    isLoading: loadingRevenue,
    error: revenueError
  } = useMonthlyRevenue();
  const {
    isAuthenticated
  } = useAdminAuth();
  useEffect(() => {
    if (isAuthenticated) {
      fetchStats();
    }
  }, [isAuthenticated, fetchStats]);
  const monthlyData = monthlyRevenue?.map(item => ({
    ...item,
    name: MONTHS[item.month - 1],
    revenue: Number(item.revenue),
    pending_revenue: Number(item.pending_revenue)
  })) || [];
  return <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-200">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <h1 className="text-4xl font-bold text-gray-900">
                Dashboard Overview
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                Monitor your platform's performance and metrics
              </p>
            </div>

            {(statsError || revenueError) && <Alert variant="destructive" className="mb-6">
                <AlertTriangle className="h-4 w-4" />
                <AlertDescription>
                  There was a problem loading some dashboard data. Please refresh to try again.
                </AlertDescription>
              </Alert>}

            {statsLoading || loadingRevenue ? <div className="flex justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div> : <>
                <SummaryCards totalRevenue={stats?.total_revenue || 0} totalUnpaidRevenue={stats?.total_unpaid_revenue || 0} totalPaidBills={stats?.total_paid_bills || 0} totalPendingBills={stats?.total_pending_bills || 0} totalCancelledBills={stats?.total_cancelled_bills || 0} />

                <RevenueChart data={monthlyData} />

                <SubscriptionCharts productSubscriptions={stats?.product_subscriptions || []} planSubscriptions={stats?.plan_subscriptions || []} schoolSubscriptions={stats?.school_subscriptions || []} />
              </>}
          </div>
        </div>
      </div>
    </SidebarProvider>;
};
export default AdminDashboard;